export const PricingCategoriesResource = {
  name: "Pricing Categories",
  path: "/inventory/pricing/pricing-categories",
  access: ["read-pricings"],
};
